export default "__VITE_ASSET__WJAvdafQ__"